import React from 'react';
import { DEFAULT_ICON_SIZE } from '../../constants';
import type { GoIconProps } from '../../types';

const GoBackToFiverrIcon = ({ size = DEFAULT_ICON_SIZE, color = 'currentColor' }: GoIconProps) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M13 21L13.6626 20.7662C16.2413 19.856 17.5307 19.4009 18.2654 18.3626C19 17.3242 19 15.9569 19 13.2222L19 10.7778C19 8.0431 19 6.6758 18.2654 5.6374C17.5307 4.5991 16.2413 4.144 13.6626 3.2338L13 3"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
        />
        <path
            d="M3 12L13 12M3 12C3 12.7002 4.9943 14.0085 5.5 14.5M3 12C3 11.2998 4.9943 9.9915 5.5 9.5"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M13 21L13.6626 20.7662C16.2413 19.856 17.5307 19.4009 18.2654 18.3626C19 17.3242 19 15.9569 19 13.2222L19 10.7778C19 8.0431 19 6.6758 18.2654 5.6374C17.5307 4.5991 16.2413 4.144 13.6626 3.2338L13 3"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
        />
        <path
            d="M3 12L13 12M3 12C3 12.7002 4.9943 14.0085 5.5 14.5M3 12C3 11.2998 4.9943 9.9915 5.5 9.5"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
GoBackToFiverrIcon.id = 'GoBackToFiverrIcon';
GoBackToFiverrIcon.displayName = 'GoBackToFiverrIcon';
export default GoBackToFiverrIcon;
